import styled, { keyframes } from "styled-components";

const ellipsis1 = keyframes`
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
`;

const ellipsis3 = keyframes`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
`;

const ellipsis2 = keyframes`
  0% {
    transform: translate(0, 0);
  }
  100% {
    // can't use css vars in styled component's keyframes 🤦‍♂️ - should be:
    // transform: translate(calc(3 * var(--container-width)/10)), 0);
    transform: translate(12px, 0);
  }
`;

const Container = styled.div<{ color?: string }>`
  --container-width: 40px;
  --container-height: 20px;
  --pip-diameter: 7px;

  display: inline-block;
  position: relative;

  width: var(--container-width);
  height: var(--container-height);

  & div {
    position: absolute;
    top: calc((var(--container-height) - var(--pip-diameter)) / 2);
    width: var(--pip-diameter);
    height: var(--pip-diameter);
    border-radius: 50%;
    background: ${(props) => props.color || "#fff"};
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }

  & div:nth-child(1) {
    left: calc(var(--container-width) / 10);
    animation: ${ellipsis1} 0.6s infinite;
  }

  & div:nth-child(2) {
    left: calc(var(--container-width) / 10);
    animation: ${ellipsis2} 0.6s infinite;
  }

  & div:nth-child(3) {
    left: calc(4 * var(--container-width) / 10);
    animation: ${ellipsis2} 0.6s infinite;
  }

  & div:nth-child(4) {
    left: calc(7 * var(--container-width) / 10);
    animation: ${ellipsis3} 0.6s infinite;
  }
`;

type LoadingSpinnerProps = {
  color?: string;
  className?: string;
  label?: string;
};

const LoadingSpinner = ({
  color,
  className,
  label = "Loading",
}: LoadingSpinnerProps) => (
  <Container
    color={color}
    className={className}
    aria-label={label}
    aria-busy="true"
    aria-live="polite"
  >
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </Container>
);

export default LoadingSpinner;
